export const mainHeaderHeight = 64;

export const drawerWidth = 360;
